import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { URL_DOCUWARE } from '../base/util/url-util';
import { AnexarImagensService } from '../anexar-imagens/anexar-imagens.service';

@Component({
    selector: 'app-get-image',
    templateUrl: './get-image.component.html',
    styleUrls: ['./get-image.component.css']
})
export class GetImageComponent implements OnInit {

    docuwareID: string = '';

    constructor(
        private anexarImagensService: AnexarImagensService, private route: ActivatedRoute
    ) {}

    ngOnInit() {
        
        //recupera do route
	  	this.route.params.subscribe(params => {
	       this.docuwareID =  params['docuwareID'];
	    });
	    
    }
}


// WEBPACK FOOTER //
// ./src/app/components/get-image/get-image.component.ts